import { render, staticRenderFns } from "./addOaWorkflow.vue?vue&type=template&id=f5042f6a"
import script from "./addOaWorkflow.vue?vue&type=script&lang=js"
export * from "./addOaWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports